module.exports = __webpack_public_path__ + "static/media/kv-zh-Hans.65f9c0c4.jpg";